export const menu = [
  { label: "About us", to: "/about" },
  { label: "Projects", to: "/projects" },
  { label: "Patterns", to: "/patterns" },
  { label: "Schedule", to: "/schedule" },
  { label: "Contact us", to: "/contact" },
];
